import { Action, Mutation } from "../types";
import axios from "axios";

export default {
  [Action.LOGOUT]({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_API_URL + "session")
        .then((resp) => {
          commit(`${Mutation.LOGOUT}`);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
